<template>
    <div class="feedback">
        <div class="feed-wraper">
            <div class="feed-item">
                <div class="feed-label required" v-t="'Qtype'"></div>
                <div class="feed-types">
                    <div :class="`feed-type${ checked.indexOf(1) > -1 ? ' selected': ''}`" @click="check(1)">
                        <span class="checkbox"></span>
                        <span class="feed-text" v-t="'Cannotpreview'"></span>
                    </div>
                    <div :class="`feed-type${ checked.indexOf(2) > -1 ? ' selected': ''}`" @click="check(2)">
                        <span class="checkbox"></span>
                        <span class="feed-text" v-t="'Contentp'"></span>
                    </div>
                    <div :class="`feed-type${ checked.indexOf(3) > -1 ? ' selected': ''}`" @click="check(3)">
                        <span class="checkbox"></span>
                        <span class="feed-text" v-t="'Other'"></span>
                    </div>
                </div>
            </div>
            <div class="feed-item">
                <div class="feed-label required" v-t="'Qdesc'"></div>
                <div class="feed-types">
                    <el-input
                        type="textarea"
                        :rows="3"
                        class="feed-content"
                        :placeholder="$t('Pcontent')"
                        v-model="content">
                        </el-input>
                </div>
            </div>
            <div class="feed-item">
                <div class="feed-label">
                    <p v-t="'Images'"></p>
                </div>
                <div class="feed-types feed-images">
                    <div class="feed-image-box clearfix">
                        <div class="image-row" :style="{width: `${92*(imageList.length + 1)}px`}">
                            <label for="image-input" class="feed-image add-image">
                                <i class="el-icon-plus"></i>
                            </label>
                            <!-- <div class="feed-image" v-for="item in 9" :key="item">
                                <img src="https://s3.us-west-2.amazonaws.com/feedback-office-wps-com/baa4c410-fd62-5d4f-370f-20915f665454.png" class="image-item" alt="">
                                <span class="close-feed-image el-icon-close"></span>
                            </div> -->
                            <div class="feed-image" v-for="(item,i) in imageList" :key="i">
                                <loading v-if="item.loading" />
                                <img :src="item.base64" class="image-item" alt="">
                                <span v-if="!item.loading" @click="deleteItem(item.id)" class="close-feed-image el-icon-close"></span>
                            </div>
                        </div>
                        
                    </div>
                    <p class="subtip" v-t="'Feedtip'"></p>
                </div>
                
            </div>
            <div class="feed-item">
                <div class="feed-label" v-t="'Email'"></div>
                <div class="feed-types">
                    <el-input
                        class="feed-content"
                        :placeholder="$t('Econtent')"
                        v-model="email">
                        </el-input>
                </div>
            </div>
            <div class="feed-item" v-if="route == 'preview' || route == 'previewHistory'">
                <div class="feed-label"></div>
                <div class="feed-types">
                    <div :class="`feed-type${link ? ' selected' : ''}`" @click="checklink">
                        <span class="checkbox"></span>
                        <span class="feed-text" v-t="'Sendaddress'"></span>
                    </div>
                </div>
            </div>
            <input @change="uploadImage" ref="fileinput" multiple type="file" accept="image/gif, image/jpg,image/png,image/webp,image/bmp,image/jpeg" id="image-input">
        </div>
        <div class="dialog-foot">
            <el-button size="mini" @click="close" v-cloak>{{$t('Cancel')}}</el-button><el-button :disabled="!checked.length || !content" @click="create" type="primary" size="mini" v-cloak>{{$t('Submit')}}</el-button>
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import {feedback} from '../../config'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
            content: '',
            email: '',
            imageList: [],
            files: [],
            checked: [3],
            link: false
        }
    },
    components:{
        Loading
    },
    created(){
        this.$axios.get(`${feedback}/auth`)
    },
    computed:{
        ...mapState([
            'route'
        ]),
        ...mapState('user',[
            'id',
            'regregion',
            'regip',
            'name'
        ]),
        desc(){
            let result = `${this.content.replace(/&/g,'')}$$type=${this.checked.join(',')}$$ua=${navigator.userAgent}$$userid=${this.id}$$nickname=${this.name}$$regip=${this.regip}$$regregion=${this.regregion}$$date=${(new Date()).getTime()}$$language=${navigator.language}$$email=${this.email.replace(/&/g,'')}`
            result = this.link ? `${result}$$link=https://drive.wps.com${this.$route.fullPath}` : result 
            return result
        }
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        checklink(){
            this.link = !this.link
        },
        check(id){
            let idx = this.checked.indexOf(id) 
            idx < 0 ? this.checked.push(id) : this.checked.splice(idx,1)
        },
        async create(){
            let files = this.imageList.map(item => {
                let {file_name,size,url} = item
                return {
                    file_name,
                    size,
                    url
                }
            })
            let data = {
                    files,
                    feel: 1,
                    desc: this.desc,
                    contact: this.email.replace(/&/g,''),
                    source: 1,
                    modular: 5,
                    client_version: "",
                    client_dict_src: "",
                    client_lang: navigator.language,
                    system_lang: "",
                    license_active: 0
            }
            let result = await this.$axios.post(`${feedback}/feedback/insert`,`data=${JSON.stringify(data)}`,{
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            if (result.status == 200 && result.data.success) {
                this.$message.success(this.$t('Thanks'))
                this.close()
            }else{
                this.$message.success(this.$t('Subfiled'))
            }
            
        },
        guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        },
        async upload(files,idx){
            let current = files[idx]
            let nameidx = current.name.lastIndexOf('.')
            let ext = current.name.slice(nameidx)
            let key = `${this.guid()}${ext}`
            let id = this.imageList.length
            this.showImages(current)
            let result = await this.$axios.get(`${feedback}/s3Auth/presign?key=${key}`)

            
            if (result.status == 200) {
                let {object:{
                    url,
                    fields
                }} = result.data

                let params = new FormData()
                Object.keys(fields).map(item => {
                    params.append(item,fields[item])
                })
                params.append('file',current)
                let {status} = await this.$axios.post(url,params)
                if (status >= 200 && status < 300) {
                    let list = this.imageList.map(item => {
                        if (item.id === id) {
                            item.url = `${url}/${key}`
                            item.loading = false
                        }
                        return item
                    })
                    this.imageList = list
                }else{
                    this.imageList.splice(0,1)
                }
                idx + 1 < files.length ? this.upload(files,idx+1) : this.$refs.fileinput.value = ''
            }else {
                this.imageList.splice(0,1)
                this.$message.error(this.$t('Uploadfailed'))
            }
            
        },
        async uploadImage(e){
            if (this.imageList.length + e.target.files.length > 9) {
                this.$message.error(this.$t('Overlimit'))
                return
            }
            await this.upload(e.target.files,0)
        },
        showImages(item){
            let type = item.type.split('/')[0]
            if (type != 'image') {
                this.$message.error(this.$t('Errimg'))
                return
            }
            let idx = item.name.lastIndexOf('.')
            let ext = item.name.slice(idx)
            let key = `${this.guid()}${ext}`
            let size = item.size
            let fr = new FileReader()
            fr.readAsDataURL(item)
            fr.onload = async () => {
                this.imageList.unshift({
                    id: this.imageList.length,
                    loading: true,
                    file_name: key,
                    base64: fr.result,
                    size
                })
            }
        },
        deleteItem(id){
            let list = this.imageList.filter(item => item.id !== id)
            this.imageList = list

        }
        

    }
}
</script>

<style>
.feed-wraper{
    padding: 16px 30px 0 16px;
}
.feed-item,.feed-type{
    display: flex;
    min-width: 0;
    margin-bottom: 14px;
}
.feed-types{
    flex: 1;
    min-width: 0;
}
.feed-type .checkbox{
    position: relative;
    display: inline-block;
    margin-right: 10px;
    margin-top: 0;
}
.feed-type{
    cursor: pointer;
}
.feed-label{
    flex: 0 0 100px;
    line-height: 22px;
}
.feed-content{
    width: 100%;
}
.feed-image{
    width: 80px;
    height: 80px;
    float: left;
    display: flex;
    align-items: center;
    text-align: center;
    margin-right: 10px;
    border: 1px solid #f2f2f2;
    background-size: cover;
    background-position: center center;
}
.image-item{
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
}
.feed-image{
    position: relative;
    background: #f2f2f2;
}
.feed-image .showloadingbox .loader{
    width: 30px;
}
.feed-image .showloadingbox{
    background: rgba(0,0,0,.08);
}
.feed-image:hover .close-feed-image{
    display: block;
}
.close-feed-image{
    position: absolute;
    width: 20px;
    height: 20px;
    background: #fff;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
    right: -10px;
    top: -10px;
    border-radius: 50%;
    color: #2e68f8;
    box-shadow: 0 0 6px rgba(0,0,0,.2);
    display: none;
}
.add-image{
    border: 1px solid #dcdfe6;
    position: relative;
    cursor: pointer;
    background: #fff;
}
.add-image:hover{
    border-color: #2e68f8;
}
.add-image:hover .el-icon-plus{
    color: #2e68f8;
}
.add-image .el-icon-plus{
    color: #dcdfe6;
    display: inline-block;
    font-size: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}
#image-input{
    display: none;
}
.feed-label.required:after{
    content: '*';
    color: red;
    font-size: 20px;
    margin: 4px 0 0 4px;
    vertical-align: top;
}
.subtip{
    margin-top: 8px;
    color: #666;
}
.feed-image-box{
    width: 100%;
    overflow-x: auto;
    padding-top: 10px;
    margin-top: -10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/Feedback.vue